import { jsx, jsxs } from 'react/jsx-runtime';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog.js';
import { Button } from '../page-layout/Button.js';

/**
 * Reusable confirmation dialog component for CRUD operations
 * @param open - Whether the dialog is open
 * @param onOpenChange - Callback when dialog open state changes
 * @param title - Dialog title
 * @param description - Optional dialog description
 * @param confirmText - Text for confirm button (defaults to "Confirm")
 * @param cancelText - Text for cancel button (defaults to "Cancel")
 * @param variant - Button variant for confirm action
 * @param loading - Whether the confirm action is loading
 * @param onConfirm - Callback when confirm button is clicked
 */
function ConfirmDialog({ open, onOpenChange, title, description, confirmText = 'Confirm', cancelText = 'Cancel', variant = 'default', loading = false, onConfirm, }) {
    const handleConfirm = async () => {
        await onConfirm();
        onOpenChange(false);
    };
    return (jsx(Dialog, { open: open, onOpenChange: onOpenChange, children: jsxs(DialogContent, { children: [jsxs(DialogHeader, { children: [jsx(DialogTitle, { children: title }), description && jsx(DialogDescription, { children: description })] }), jsxs(DialogFooter, { children: [jsx(Button, { variant: "outline", onClick: () => onOpenChange(false), disabled: loading, children: cancelText }), jsx(Button, { variant: variant, onClick: handleConfirm, loading: loading, disabled: loading, children: confirmText })] })] }) }));
}

export { ConfirmDialog };
//# sourceMappingURL=ConfirmDialog.js.map
